import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  MenuItem,
  CircularProgress,
  Snackbar,
  Alert,
  InputAdornment,
  Paper,
  Divider,
  Collapse,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import axios from "axios";
import { API_URL } from "../../../Config/api";

const PackagePayment = ({ eveId, callerId, summaryData, onClose }) => {
  const accessToken = localStorage.getItem("token");

  // Core States
  const [walletBalance, setWalletBalance] = useState(0);
  const [useWallet, setUseWallet] = useState(false);
  const [inputWalletAmount, setInputWalletAmount] = useState("");
  const [amount, setAmount] = useState("");
  const [paidBy, setPaidBy] = useState("");
  const [remark, setRemark] = useState("");
  const [paymentMode, setPaymentMode] = useState(1);
  const [transactionId, setTransactionId] = useState("");
  const [utrNum, setUtrNum] = useState("");
  const [cardNum, setCardNum] = useState("");
  const [chequeNum, setChequeNum] = useState("");
  const [chequeDate, setChequeDate] = useState("");
  const [bankName, setBankName] = useState("");

  const [loading, setLoading] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const paymentModes = [
    { value: 1, label: "Cash" },
    { value: 2, label: "Cheque" },
    { value: 3, label: "Online" },
    { value: 4, label: "Card" },
    { value: 5, label: "QR Code" },
    { value: 6, label: "NEFT" },
  ];

  // --- CALCULATION LOGIC ---
  const packageTotal = Number(summaryData?.totalAmount || 0);
  const baseAmount =
    summaryData?.remainingAmount !== undefined
      ? Number(summaryData.remainingAmount)
      : packageTotal;

  // Real-time wallet logic
  const parsedInputWallet = Number(inputWalletAmount) || 0;
  const walletDeduction = useWallet ? parsedInputWallet : 0;
  const remainingWalletBalance = walletBalance - walletDeduction;

  // Final amount to be paid after wallet deduction
  const finalPayable = Math.max(0, baseAmount - walletDeduction);

  // User currently entering amount
  const userPayingAmount = Number(amount) || 0;

  // Remaining amount left AFTER user pays this custom amount
  const pendingAfterPayment = Math.max(0, finalPayable - userPayingAmount);

  // Default auto-fill amount when finalPayable changes
  useEffect(() => {
    setAmount(finalPayable.toString());
  }, [finalPayable]);

  // Clear wallet input if unchecked
  useEffect(() => {
    if (!useWallet) {
      setInputWalletAmount("");
    }
  }, [useWallet]);

  useEffect(() => {
    const fetchWalletMoney = async () => {
      if (callerId) {
        try {
          const response = await axios.get(
            `${API_URL}/packages/walletMoney/?caller_id=${callerId}`,
            { headers: { Authorization: `Bearer ${accessToken}` } },
          );
          setWalletBalance(response.data?.wallet_Amount || 0);
        } catch (error) {
          console.error("Error fetching wallet money:", error);
        }
      }
    };
    fetchWalletMoney();
  }, [callerId, accessToken]);

  const handlePaymentSubmit = async () => {
    // --- VALIDATIONS ---
    if (useWallet) {
      if (parsedInputWallet > walletBalance) {
        setSnackbar({
          open: true,
          message: "Entered amount exceeds wallet balance!",
          severity: "error",
        });
        return;
      }
      if (parsedInputWallet > baseAmount) {
        setSnackbar({
          open: true,
          message: "Wallet amount cannot exceed the total bill!",
          severity: "error",
        });
        return;
      }
    }

    if (userPayingAmount > finalPayable) {
      setSnackbar({
        open: true,
        message: "Amount paid cannot exceed the Net Payable amount!",
        severity: "error",
      });
      return;
    }

    if (userPayingAmount < 0) {
      setSnackbar({
        open: true,
        message: "Amount cannot be negative!",
        severity: "error",
      });
      return;
    }

    // if (finalPayable > 0 && userPayingAmount > 0 && !paidBy) {
    //   setSnackbar({
    //     open: true,
    //     message: "Paid By is required when paying an amount!",
    //     severity: "error",
    //   });
    //   return;
    // }

    if (userPayingAmount > 0) {
      // CASH
      if (Number(paymentMode) === 1) {
      }

      // CHEQUE
      else if (Number(paymentMode) === 2) {
        if (!chequeNum.trim()) {
          setSnackbar({
            open: true,
            message: "Cheque Number is required.",
            severity: "error",
          });
          return;
        }

        if (!chequeDate) {
          setSnackbar({
            open: true,
            message: "Cheque Date is required.",
            severity: "error",
          });
          return;
        }

        if (!bankName.trim()) {
          setSnackbar({
            open: true,
            message: "Bank Name is required.",
            severity: "error",
          });
          return;
        }
      }

      // ONLINE
      else if (Number(paymentMode) === 3) {
        if (!transactionId.trim()) {
          setSnackbar({
            open: true,
            message: "Transaction ID is required for Online payment.",
            severity: "error",
          });
          return;
        }
      }

      // CARD
      else if (Number(paymentMode) === 4) {
        if (!cardNum.trim()) {
          setSnackbar({
            open: true,
            message: "Card Number is required for Card payment.",
            severity: "error",
          });
          return;
        }

        if (!transactionId.trim()) {
          setSnackbar({
            open: true,
            message: "Transaction ID is required for Card payment.",
            severity: "error",
          });
          return;
        }
      }

      // QR CODE
      else if (Number(paymentMode) === 5) {
        if (!transactionId.trim()) {
          setSnackbar({
            open: true,
            message: "Transaction ID is required for QR Code payment.",
            severity: "error",
          });
          return;
        }

        // UTR is OPTIONAL
      }

      // NEFT
      else if (Number(paymentMode) === 6) {
        if (!transactionId.trim()) {
          setSnackbar({
            open: true,
            message: "Transaction ID is required for NEFT payment.",
            severity: "error",
          });
          return;
        }
      }
    }


    const paymentData = {
      // paid_by: paidBy || "Self",
      paid_by: summaryData?.patientName,
      amount: userPayingAmount,
      mode: userPayingAmount === 0 ? 0 : Number(paymentMode),
    };

    // Cash
    if (Number(paymentMode) === 1) {
    }

    // Cheque
    else if (Number(paymentMode) === 2) {
      paymentData.cheque_num = chequeNum;
      paymentData.date = chequeDate;
      paymentData.bank_name = bankName;
      paymentData.utr_num = utrNum;
    }

    // Online
    else if (Number(paymentMode) === 3) {
      paymentData.transaction_id = transactionId;
      paymentData.utr_num = utrNum;
    }

    // Card
    else if (Number(paymentMode) === 4) {
      paymentData.card_num = cardNum;
      paymentData.transaction_id = transactionId;
      paymentData.utr_num = utrNum;
    }

    // QR Code
    else if (Number(paymentMode) === 5) {
      paymentData.transaction_id = transactionId;
      paymentData.utr_num = utrNum;
    }

    // NEFT
    else if (Number(paymentMode) === 6) {
      paymentData.transaction_id = transactionId;
      paymentData.utr_num = utrNum;
    }


    // Exact Payload format
    const payload = {
      wallet_status: useWallet && walletDeduction > 0,
      wallet_amount: walletDeduction,
      remark: remark,
      payment: paymentData,
      // payment: {
      //   paid_by: paidBy || "Self",
      //   amount: userPayingAmount,
      //   mode: userPayingAmount === 0 ? 0 : paymentMode,
      //   card_num: cardNum,
      //   transaction_id: transactionId,
      //   utr_num: utrNum,
      // },
    };

    try {
      setLoading(true);
      const response = await axios.post(
        `${API_URL}/packages/MakePayment/?eve_id=${eveId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200 || response.status === 201) {
        setSnackbar({
          open: true,
          message: "Payment successful!",
          severity: "success",
        });
        setTimeout(() => onClose?.(), 1500);
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Payment failed. Please try again.",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        p: 1.5,
        background: "#f8fafc",
        borderRadius: 2,
        boxSizing: "border-box",
      }}
    >
      <Grid container spacing={1.5}>
        {/* Premium Header Banner */}
        <Grid item xs={12}>
          <Box
            sx={{
              background: "linear-gradient(135deg, #0f172a 0%, #334155 100%)",
              borderRadius: "12px",
              color: "#ffffff",
              p: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              boxShadow: "0 4px 12px -2px rgba(0, 0, 0, 0.15)",
            }}
          >
            <Stack direction="row" spacing={1} alignItems="center">
              <ReceiptLongIcon sx={{ color: "#14b8a6", fontSize: 24 }} />
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                Total Payable
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center">
              <CurrencyRupeeIcon
                sx={{ fontSize: 22, color: "#14b8a6", mr: 0.5 }}
              />
              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                {finalPayable}
              </Typography>
            </Stack>
          </Box>
        </Grid>

        {/* Modern Service Summary Card */}
        <Grid item xs={12}>
          <Paper
            elevation={0}
            sx={{ p: 2, borderRadius: 3, border: "1px solid #e2e8f0" }}
          >
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 700, color: "#1e293b", mb: 1 }}
            >
              Service Summary
            </Typography>

            <Stack spacing={1}>
              <Box display="flex" justifyContent="space-between">
                <Typography variant="body2" color="text.secondary">
                  Patient Name
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {summaryData?.patientName || "N/A"}
                </Typography>
              </Box>
              <Box display="flex" justifyContent="space-between">
                <Typography variant="body2" color="text.secondary">
                  Event ID
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {eveId || "N/A"}
                </Typography>
              </Box>
              <Box display="flex" justifyContent="space-between">
                <Typography variant="body2" color="text.secondary">
                  Package Name
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {summaryData?.packageName || "N/A"}
                </Typography>
              </Box>

              <Divider sx={{ my: 0.5, borderStyle: "dashed" }} />

              <Box display="flex" justifyContent="space-between">
                <Typography variant="body2" color="text.secondary">
                  Total Package Cost
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  ₹ {packageTotal}
                </Typography>
              </Box>
              <Box display="flex" justifyContent="space-between">
                <Typography variant="body2" color="text.secondary">
                  Pending / Payable Amount
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 600, color: "#e11d48" }}
                >
                  ₹ {baseAmount}
                </Typography>
              </Box>

              {useWallet && walletDeduction > 0 && (
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="body2" color="text.secondary">
                    Wallet Applied
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: "#f43f5e" }}
                  >
                    - ₹ {walletDeduction}
                  </Typography>
                </Box>
              )}

              <Box
                display="flex"
                justifyContent="space-between"
                sx={{ mt: 0.5, p: 1, background: "#f1f5f9", borderRadius: 1.5 }}
              >
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 700, color: "#334155" }}
                >
                  Net Payable Amount
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 800, color: "#0f172a" }}
                >
                  ₹ {finalPayable}
                </Typography>
              </Box>
            </Stack>
          </Paper>
        </Grid>

        {/* Premium Interactive Wallet Section */}
        <Grid item xs={12}>
          <Paper
            elevation={0}
            sx={{
              p: 1.5,
              borderRadius: 3,
              border: `1px solid ${useWallet ? "#14b8a6" : "#e2e8f0"}`,
              background: useWallet ? "#f0fdfa" : "#ffffff",
              transition: "all 0.3s ease",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <AccountBalanceWalletIcon
                  sx={{
                    fontSize: 20,
                    color: useWallet ? "#0d9488" : "#94a3b8",
                  }}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={useWallet}
                      onChange={(e) => setUseWallet(e.target.checked)}
                      disabled={walletBalance <= 0}
                      sx={{
                        color: "#14b8a6",
                        "&.Mui-checked": { color: "#0d9488" },
                        py: 0,
                      }}
                    />
                  }
                  label={
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600, color: "#1e293b" }}
                    >
                      Use Wallet
                    </Typography>
                  }
                  sx={{ m: 0 }}
                />
              </Stack>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: remainingWalletBalance < 0 ? "#ef4444" : "#0f172a",
                }}
              >
                Balance: ₹ {remainingWalletBalance}
              </Typography>
            </Box>

            <Collapse in={useWallet}>
              <Box sx={{ mt: 1.5 }}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Enter amount to deduct from Wallet"
                  type="number"
                  value={inputWalletAmount}
                  onChange={(e) => setInputWalletAmount(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">₹</InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 1.5,
                      backgroundColor: "#fff",
                      "&.Mui-focused fieldset": { borderColor: "#14b8a6" },
                    },
                  }}
                />
              </Box>
            </Collapse>
          </Paper>
        </Grid>

        {/* Dynamic Payment Fields with Detailed Breakdown */}
        <Grid item xs={12}>
          <Collapse in={finalPayable > 0 || userPayingAmount > 0}>
            <Paper
              elevation={0}
              sx={{ p: 2, borderRadius: 3, border: "1px solid #e2e8f0" }}
            >
              {/* --- DETAILED REMAINING AMOUNT BOX --- */}
              <Box
                sx={{
                  mb: 2,
                  p: 1.5,
                  background: pendingAfterPayment > 0 ? "#fff1f2" : "#f0fdfa",
                  borderRadius: 2,
                  border:
                    pendingAfterPayment > 0
                      ? "1px dashed #fda4af"
                      : "1px dashed #5eead4",
                }}
              >
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                  <InfoOutlinedIcon
                    sx={{
                      fontSize: 18,
                      color: pendingAfterPayment > 0 ? "#e11d48" : "#0d9488",
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 600,
                      color: pendingAfterPayment > 0 ? "#be123c" : "#0f766e",
                    }}
                  >
                    Payment Calculation Details
                  </Typography>
                </Stack>
                <Stack direction="row" justifyContent="space-between" mb={0.5}>
                  <Typography variant="body2" color="text.secondary">
                    Net Payable:
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    ₹ {finalPayable}
                  </Typography>
                </Stack>
                <Stack direction="row" justifyContent="space-between" mb={0.5}>
                  <Typography variant="body2" color="text.secondary">
                    Paying Now:
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: "#2563eb" }}
                  >
                    ₹ {userPayingAmount}
                  </Typography>
                </Stack>
                <Divider sx={{ my: 0.5 }} />
                <Stack direction="row" justifyContent="space-between">
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 700, color: "#1e293b" }}
                  >
                    Remaining After Payment:
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 800,
                      color: pendingAfterPayment > 0 ? "#ef4444" : "#10b981",
                    }}
                  >
                    ₹ {pendingAfterPayment}
                  </Typography>
                </Stack>
              </Box>

              <Grid container spacing={1.5}>
                <Grid item xs={12} sm={6}>
                  {/* EDITABLE AMOUNT FIELD */}
                  <TextField
                    fullWidth
                    label="Amount Paid Now"
                    size="small"
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    error={userPayingAmount > finalPayable}
                    helperText={
                      userPayingAmount > finalPayable
                        ? "Cannot exceed Net Payable!"
                        : ""
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">₹</InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Paid By"
                    size="small"
                    value={summaryData?.patientName || "N/A"}
                  // value={paidBy}
                  // onChange={(e) => setPaidBy(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    label="Payment Mode"
                    size="small"
                    value={paymentMode}
                    onChange={(e) => setPaymentMode(e.target.value)}
                  >
                    {paymentModes.map((opt) => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {paymentMode === 4 && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Card Number"
                      size="small"
                      value={cardNum}
                      onChange={(e) => setCardNum(e.target.value)}
                    />
                  </Grid>
                )}

                {paymentMode === 2 && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Cheque Number"
                        size="small"
                        value={chequeNum}
                        onChange={(e) => setChequeNum(e.target.value)}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Cheque Date"
                        type="date"
                        size="small"
                        value={chequeDate}
                        onChange={(e) => setChequeDate(e.target.value)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Bank Name"
                        size="small"
                        value={bankName}
                        onChange={(e) => setBankName(e.target.value)}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="UTR"
                        size="small"
                        value={utrNum}
                        onChange={(e) => setUtrNum(e.target.value)}
                      />
                    </Grid>
                  </>
                )}

                {[3, 4, 5, 6].includes(paymentMode) && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="Transaction ID"
                        size="small"
                        value={transactionId}
                        onChange={(e) => setTransactionId(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="UTR Number"
                        size="small"
                        value={utrNum}
                        onChange={(e) => setUtrNum(e.target.value)}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </Paper>
          </Collapse>
        </Grid>

        {/* Remarks Section */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            size="small"
            label="Remarks / Notes (Optional)"
            multiline
            rows={2}
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
          />
        </Grid>

        {/* Premium Save Button */}
        <Grid
          item
          xs={12}
          sx={{ display: "flex", justifyContent: "center", mt: 1 }}
        >
          <Button
            variant="contained"
            onClick={handlePaymentSubmit}
            disabled={loading || userPayingAmount > finalPayable}
            sx={{
              py: 1,
              px: 5,
              background: "linear-gradient(90deg, #3b82f6 0%, #2563eb 100%)",
              borderRadius: "24px",
              fontSize: "15px",
              fontWeight: 600,
              textTransform: "none",
              boxShadow: "0 6px 15px -4px rgba(37, 99, 235, 0.5)",
              transition: "transform 0.2s ease, box-shadow 0.2s ease",
              "&.Mui-disabled": { background: "#cbd5e1", color: "#64748b" },
              "&:hover": {
                transform: "translateY(-1px)",
                boxShadow: "0 8px 20px -4px rgba(37, 99, 235, 0.6)",
                background: "linear-gradient(90deg, #2563eb 0%, #1d4ed8 100%)",
              },
            }}
          >
            {loading ? (
              <CircularProgress size={22} color="inherit" />
            ) : (
              "Complete Payment"
            )}
          </Button>
        </Grid>
      </Grid>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          sx={{ width: "100%", borderRadius: 2, fontWeight: 600 }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default PackagePayment;
